/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Passwordstrengthmedium2Inputs */

const en_passwordstrengthmedium2 = /** @type {(inputs: Passwordstrengthmedium2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medium`)
};

const de_passwordstrengthmedium2 = /** @type {(inputs: Passwordstrengthmedium2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mittel`)
};

/**
* | output |
* | --- |
* | "Medium" |
*
* @param {Passwordstrengthmedium2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const passwordstrengthmedium2 = /** @type {((inputs?: Passwordstrengthmedium2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Passwordstrengthmedium2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_passwordstrengthmedium2(inputs)
	return de_passwordstrengthmedium2(inputs)
});
export { passwordstrengthmedium2 as "passwordStrengthMedium" }